import { backendGet, backendPost } from '../lib/backendClient';

export async function getEnviosViagensConfig() {
  return await backendGet('/api/envios-viagens/config');
}

export async function estimateEnviosViagens(payload) {
  return await backendPost('/api/envios-viagens/estimate', payload || {});
}

export async function createEnviosViagensOrder(payload) {
  return await backendPost('/api/envios-viagens/orders', payload || {});
}
